import { formatDateTime } from '@pocapan/shared/utils/DateUtil';
import ChatBadge from './ChatBadge';

interface ChatTextBubbleProps {
  isOther: boolean;
  text?: string;
  children?: React.ReactNode;
  likesCount?: number;
  commentsCount?: number;
  isLiked?: boolean;
  onLike?: () => void;
  onComment?: () => void;
  onBubbleClick?: () => void;
  timeStamp?: number;
}

const ChatTextBubble = ({
  isOther,
  text,
  children,
  likesCount,
  commentsCount,
  isLiked,
  onLike,
  onComment,
  onBubbleClick,
  timeStamp
}: ChatTextBubbleProps) => {
  const hasLikesCount = likesCount && likesCount > 0;
  const hasCommentsCount = commentsCount && commentsCount > 0;

  const childrenArray = Array.isArray(children) ? children : children ? [children] : [];
  const hasContent = childrenArray.length > 0 || text;

  // text가 있으면 모든 children을 렌더링하고 text 옆에 timestamp
  // text가 없으면 마지막 child 옆에 timestamp
  const restChildren = text ? childrenArray : childrenArray.slice(0, -1);
  const lastChild =
    !text && childrenArray.length > 0 ? childrenArray[childrenArray.length - 1] : null;

  return (
    <div className="relative flex flex-col">
      <div className={`flex flex-col -space-y-[4px] ${isOther ? 'items-start' : 'items-end'}`}>
        {restChildren}

        <div className={`flex flex-row gap-[4px] items-end ${isOther ? '' : 'flex-row-reverse'}`}>
          <div
            className={`flex flex-col [&>*:last-child]:min-w-[110px] ${isOther ? 'items-start' : 'items-end'}`}
          >
            {lastChild}
            {text && (
              <button
                type="button"
                onClick={() => onBubbleClick?.()}
                className={`px-[16px] py-[14px] rounded-[16px] max-w-[212px] ${
                  isOther ? 'bg-separator1' : 'bg-primary-light dark:bg-primary-dark'
                }`}
              >
                <p
                  className={`text-[15px] leading-[18px] text-left whitespace-pre-line break-words line-clamp-3 ${
                    isOther ? 'text-text-main-lv2' : 'text-pure-white'
                  }`}
                >
                  {text}
                </p>
              </button>
            )}
          </div>
          {hasContent && timeStamp && (
            <span className="text-[11px] text-text-main-lv4 leading-[13px] whitespace-nowrap mb-[2px]">
              {formatDateTime(timeStamp * 1000, 'p')}
            </span>
          )}
        </div>
      </div>

      <div
        className={`absolute bottom-[-12px] flex gap-[2px] ${isOther ? 'left-[16px]' : 'right-[16px]'}`}
      >
        <ChatBadge
          color={isOther ? 'white' : 'purple'}
          type="like"
          state={hasLikesCount ? 'valued' : 'default'}
          count={likesCount}
          onClick={() => onLike?.()}
          isLiked={isLiked}
        />
        <ChatBadge
          color={isOther ? 'white' : 'purple'}
          type="comment"
          state={hasCommentsCount ? 'valued' : 'default'}
          count={commentsCount}
          onClick={() => onComment?.()}
        />
      </div>
    </div>
  );
};

export default ChatTextBubble;
